import React from 'react';
import ContentWithNavigationSidebar from '../legacy/layouts/ContentWithNavigationSidebar';
import Inventory from '../legacy/pages/Inventory';
import ROUTE_PATH from './routePaths';

const routes = [
  {
    exact: true,
    authenticatedRoute: true,
    path: ROUTE_PATH.INVENTORY,
    component: props => (
      <ContentWithNavigationSidebar>
        <Inventory {...props} />
      </ContentWithNavigationSidebar>
    ),
  },
  /* {
    exact: true,
    authenticatedRoute: true,
    path: `${ROUTE_PATH.REPORTS}/:reportId`,
    component: props => (
      <ContentWithNavigationSidebar>
        <ReportsReport {...props} />
      </ContentWithNavigationSidebar>
    ),
  }, */
];
export default routes;



// WEBPACK FOOTER //
// ./src/routes/inventory.jsx